import Moment from 'moment';

export default {
    install(Vue) {
        Vue.filter('ucfirst', value => {
            if (value.length <= 2) return value;

            return value[0].toUpperCase() + value.substring(1).toLowerCase();
        });

        Vue.filter('moment', (value, format) => {
            return Moment(value).format(format);
        });

        Vue.filter('or', (value, or) => {
            return value ? value : or;
        });

        Vue.filter('phone', (tel) => {
            if (!tel) { return ''; }

            let value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            let country, city, number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return tel;
            }

            if (country == 1) {
                country = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (city + '-' + number).trim();
        });

        Vue.filter('money', (n) => {
            let c = 2,
                d = '.',
                t = ',',
                s = n < 0 ? "-" : "",
                i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
                iL = i.length,
                j = iL > 3 ? iL % 3 : 0;

            return '$' + (s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : ""));
        });

        Vue.filter('ago', (value) => {
            return Moment(value + '+00:00').fromNow();
        });

        Vue.filter('agoPlain', (value) => {
            return Moment(value).fromNow(true);
        });

        Vue.filter('thousands', (input) => {
            if (typeof input == 'undefined') {
                return 0;
            }

            if (input === 0) return 0;

            if (!input) return null;

            let parts = input.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        });

        Vue.filter('two_decimals', (n) => {
            let c = 2,
                d = '.',
                t = ',',
                s = n < 0 ? "-" : "",
                i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
                iL = i.length,
                j = iL > 3 ? iL % 3 : 0;

            return (s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : ""));
        });

        Vue.filter('capitalize', (input) => {
            return input.charAt(0).toUpperCase() + input.slice(1);
        });
    }
}
